<template lang="pug">
	.tag(@click="deselect") {{item.value}}
</template>

<script>

export default {
	name: 'SearchFilterTagsItem',
	props: ["item"],
	methods: {
		deselect() {
			const data = {
				groupID: this.item.groupID,
				id: this.item.id,
				value: false
			};
			this.$emit("removefilter", data);
		}
	},
}
</script>

<style scoped lang="scss">
	.tag {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex: 1 1 max-content;
		width: max-content;
		min-width: max-content;
		padding: 0.5rem;
		background-color: $lightGray;
		font-size: 0.75rem;
		cursor: pointer;
		transition: 0.25s ease;
		@include mq(md) {
			margin-bottom: 0.5rem;
		}
		&::after {
			@include icon("close");
			margin-left: 0.5rem;
			font-size: 0.875rem;
			transform: rotate(0deg);
			transition: color 0.05s ease, transform 0.25s ease;
		}
		&:not(:last-child) {
			margin-right: 0.625rem;
		}
		&:hover {
			background-color: $primaryPurple;
			color: $white;
			&::after {
				transform: rotate(180deg);
			}
		}
	}
	
</style>